import { DefaultService } from '@/services/default'

export class DashboardService extends DefaultService {
  static resourceURL = 'dashboard/'

  static dashboard() {
    return this.execute('', 'GET')
  }
}
